import '@babel/polyfill'
import '@/registerServiceWorker'
import 'vuetify/src/stylus/app.styl'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import {
  VCard
  /* other imports ... */
}  from 'vuetify/lib';
import Notifications from 'vue-notification'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'


Vue.prototype.$API_BASE_URL = "https://sogno.andreagobetti.it/ws/";

Vue.use(Vuetify, {
    theme: {
        // Logo-Font: Ultra Fresh
        primary: '#209ecc',
        secondary: '#ffffff',
        success: '#288528',
        error: '#c01f1f',
        info: '#006061',
        warning: '#AB640D'
    },
    components: {
        VCard
       /* other imports */
    },
})

Vue.use(Notifications);


Vue.filter("datetime", function (value) {
    if (!value) {
        return "-";
    }
    value = new Date(value);
    return (
        (value.getDate() < 10 ? "0" : "") +
        value.getDate() +
        "/" +
        (value.getMonth() < 9 ? "0" : "") +
        (value.getMonth() + 1) +
        "/" +
        value.getFullYear() +
        " " +
        (value.getHours() < 10 ? "0" : "") +
        value.getHours() +
        ":" +
        (value.getMinutes() < 10 ? "0" : "") +
        value.getMinutes()
    );
});

Vue.filter("date", function (value) {
    if (!value) {
      return "-";
    }
    value = new Date(value);
    return (
      (value.getDate() < 10 ? "0" : "") +
      value.getDate() +
      "/" +
      (value.getMonth() < 9 ? "0" : "") +
      (value.getMonth() + 1) +
      "/" +
      value.getFullYear()
    );
  });

  Vue.mixin({
    data: () => ({
      window: {
        width: 0,
        height: 0
      },
    }),
    methods: {
      handleResize() {
        let vm = this;
        vm.window.width = window.innerWidth;
        vm.window.height = window.innerHeight;
      },
    },
    mounted() {
      let vm = this;
      window.addEventListener("resize", vm.handleResize);
      this.handleResize();
    },
    beforeDestroy() {
      let vm = this;
      window.removeEventListener("resize", vm.handleResize);
    },
    computed: {
      isMobile() {
        return this.window.width < 1000;
      }
    },
  });

Vue.config.productionTip = false
Vue.prototype.$http = axios.create({
    baseURL: '',
    withCredentials: true,
    validateStatus: function (status) {
        if (status >= 200 && status < 300 && status !== 204) {
            return true
        } else {
            return false
        }
    }
})
import { Device } from '@capacitor/device';


Device.getLanguageCode().then(lang => {
    switch(lang.value){
        case 'it':
        case 'it-IT':
            i18n.locale = 'it';
            break;  
        default:
            i18n.locale = 'en';
            break;
    }
});

new Vue({
    router,
    store,
    i18n,
    render: function (h) {
        return h(App)
    }
}).$mount('#app')
